module.exports = {
      id: "icon-codepen-usage",
      viewBox: "0 0 24 24",
      url: "/img/" + "063d56c0a9dcab4c3026b31719d540d0.svg#icon-codepen",
      toString: function () {
        return this.url;
      }
    }